import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, thriweDiscoveryUrl } from '../../../../Containers/Config/index.js';
import { UDPATE_PERMISSION_CHECKER, UDPATE_PERMISSION_CHECKER_SUCCESS, UDPATE_PERMISSION_CHECKER_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* updatePermissionRequest({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/request`,
      method: 'PUT',
      headers: {
        Authorization: payload?.token,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: UDPATE_PERMISSION_CHECKER_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UDPATE_PERMISSION_CHECKER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UDPATE_PERMISSION_CHECKER_ERROR, payload: error });
  }
}

export function* watchUpdatePermissionRequest() {
  yield takeEvery(UDPATE_PERMISSION_CHECKER, updatePermissionRequest);
}

function* updatePermissionRequestSaga() {
  yield all([fork(watchUpdatePermissionRequest)]);
}

export default updatePermissionRequestSaga;
